export default "__VITE_ASSET__CquLt5TJ__"